const alertMessage = (alertMessage = {}, action) => {
  switch (action.type) {
    case 'ALERT_MESSAGE':
      return action.payload
    default:
      return alertMessage
  }
}
export default alertMessage
